<!-- eslint-disable -->
<template>
    <div id="nucarf-saas-head-wrap">
        <div id="nucarf-saas-head">
            <div class="left head-left flex flex-1">
                <div>
                    <i
                        class="iconfont icon-daohang pointer font_16"
                        @click="handleClose(true)"
                        style="color: #424562; margin: 0 26px 0 15px"
                    />
                </div>
                <h2>牛卡福企业数字化平台</h2>
                <h1 class="stream">牛卡福企业数字化平台</h1>
                <div class="company-name stream">
                    <span @click="handleSwitchClick">{{
                        corporationInfo.companyName
                    }}</span>
                </div>
            </div>
            <div class="right flex stream">
                <div
                    v-if="creator || admin"
                    class="financial flex"
                    @click="handleToUrlTap('/admin')"
                >
                    <i class="iconfont el-forshezhi" />
                    <span>企业管理</span>
                </div>
                <div
                    class="financial flex"
                    @click="
                        handleToUrlTap(
                            'https://docs.qq.com/doc/DZllJQk9Bb1R2b05p?u=7711c363f1ce41da8155fb6eb7ab7298'
                        )
                    "
                >
                    <span>操作手册</span>
                </div>
                <div class="financial flex" @click="handleToUrl('/base')">
                    <i class="iconfont el-forcaiwu3" />
                    <span>财务中心</span>
                </div>
                <el-dropdown>
                    <div id="user-name" class="nav-user flex">
                        <i class="iconfont icontouxiang" />
                        <span>{{ userName ? userName : '' }}</span>
                        <i class="el-icon-arrow-down" />
                    </div>
                    <el-dropdown-menu slot="dropdown" style="width: 140px">
                        <el-dropdown-item
                            id="dropdown-change-pwd"
                            icon="iconfont iconzhongzhimima"
                            @click.native="handleToUrlTap('/changePwd')"
                            >个人中心</el-dropdown-item
                        >
                        <el-dropdown-item
                            id="dropdown-change-pwd"
                            icon="el-icon-circle-close"
                            @click.native="isDialog = true"
                            >退出登录</el-dropdown-item
                        >
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :show-close="false"
            size="283px"
        >
            <div slot="title">
                <div class="flex">
                    <img
                        src="@/assets/images/nav/nucarf.png"
                        style="
                            width: 100px;
                            height: 33px;
                            margin: 23px 117px 23px 26px;
                        "
                    />
                    <img
                        src="@/assets/images/nav/close.png"
                        class="pointer"
                        @click="handleClose(false)"
                        style="width: 17px; height: 16px; margintop: 31px"
                    />
                </div>
            </div>
            <div class="font_20 font_500 nav_prod">牛卡福产品导航</div>
            <ul class="nav_list">
                <li
                    v-for="(item, key) in imgs"
                    :key="key"
                    class="flex margin-b-20 pointer"
                    :class="active == key ? 'active' : ''"
                    @mouseenter="handleTab(key)"
                    @mousemove="handleTab(key)"
                    @click="handleClick(key, item.href)"
                >
                    <img
                        :src="item.img"
                        style="width: auto; height: 36px"
                        alt=""
                    />
                    <span>
                        <div style="fontsize: 15px" class="nav_title font_500">
                            {{ item.title }}
                        </div>
                        <div style="fontsize: 12px" class="nav_dis">
                            {{ item.dis }}
                        </div>
                    </span>
                </li>
            </ul>
        </el-drawer>
        <nf-confirm
            :show.sync="isDialog"
            :handle-save-btn-click="handlelogoutClick"
            scrollbar-h="70px"
        >
            <div slot="content">确定退出登录吗？</div>
        </nf-confirm>
        <nf-confirm :show.sync="show">
            <div slot="content">
                <div class="titleHeader">
                    <div class="left">
                        <img src="./images/lhv2DA.png" class="transform" />
                        <span
                            style="
                                display: inline-block;
                                transform: translate(0px, -10px);
                                fontsize: 16px;
                                color: hsla(0, 0%, 40%, 1);
                            "
                            >|</span
                        >
                        <div
                            style="
                                display: inline-block;
                                transform: translate(0px, -10px);
                                fontsize: 14px;
                                marginleft: 8px;
                                fontweight: 650;
                            "
                        >
                            企业实名认证
                        </div>
                    </div>
                </div>
                <div class="matter">
                    <p class="titleP">亲爱的企业管理员您好：</p>
                    <p class="titlep">
                        您的企业尚未进行企业实名认证，请点击下方认证按钮，
                        <b>3分钟立即认证</b>，即可使用全部功能。
                    </p>
                </div>
            </div>
            <div slot="footer">
                <div class="flex">
                    <span
                        v-throttle="2000"
                        class="blue"
                        @click="handleSaveBtnClick"
                        >立即认证</span
                    >
                    <span class="anout" @click="show = false">忽略</span>
                </div>
            </div>
        </nf-confirm>
    </div>
</template>

<script>
import nfConfirm from '@/components/nf-confirm/index'
import store from '@/store/index'
import { logout } from '@/api/login'
import { getCookie, delCookie } from '@/assets/cookie';
import Cookies from 'js-cookie';
export default {
  components: {
    nfConfirm,
  },
  data () {
    return {
      promptPwdWidth: '',
      isDialog: false,
      navList: [],
      maxNavList: 5,
      searchText: '',
      show: false,
      active: 2,
      drawer: false,
      direction: 'ltr',
      imgs: [
        { img: require('../../assets/images/nav/niuyunbao.png'), title: "牛运宝", dis: "一站式智慧物流服务平台", href: "https://1.nucarf" },
        { img: require('../../assets/images/nav/wanjinyou.png'), title: "万金油", dis: "智能加油管理解决方案", href: "https://vip.nucarf.net/" },
        { img: require('../../assets/images/nav/wanliu.png'), title: "万流数据", dis: "智能通行费发票解决方案", href: "https://cloud.nucarf.net" }
      ]
    }
  },
  computed: {
    companyList () {
      return store.state.companyList
    },
    admin () {
      return store.state.admin
    },
    corporationInfo () {
      return store.state.corporationInfo
    },
    userName () {
      return store.state.userName
    },
    creator () {
      return store.state.creator
    },
    corpCertityStatus () {
      return store.state.corpCertityStatus
    },
  },
  watch: {
    corporationInfo: {
      handler (v) {
        store.commit('updateCorporationInfo', v)
      },
      deep: true,
    },
    userName (n) {
      store.commit('updateUserName', n)
    },
  },
  methods: {
    getSubdomain(hostname) {
      const parts = hostname.split('.');
      console.log(parts);
      if (parts.length > 2) {
        return '.'+parts[1]+'.'+ parts[2]; 
      }
      return ''; 
    },
    handleTab (val) {
      this.active = val
    },
    handleClick (key, val) {
      if (key === 1) {
        window.open(val, '_blank')
      } else if (key === 0) {
        let res = window.location.host.substring(window.location.host.lastIndexOf('.') + 1)
        window.location.href = val + "." + res
        // window.open(val + "." + res, '_blank')
      } else {
        this.drawer = false
      }
    },
    handleClose (val) {
      if (val) {
        this.active = 2
      }
      this.drawer = val
    },
    async handlelogoutClick () {
      let res = await logout()
      try {
        if (res.code === 200) {
            if (getCookie('ShippersUserInfo')) {
                const subdomain = this.getSubdomain(window.location.hostname);
                Cookies.remove('ShippersUserInfo', { domain: subdomain});
            }
          window.location.href =
            window.location.origin.replace(
              window.location.host.split('.')[0],
              'cloud'
            ) + '/login'
        }
      } catch (error) {
        return error
      }
    },
    handleToUrlTap (link) {
      window.open(link)
    },
    handleSwitchClick () {
      if (this.companyList.length > 1) {
        this.$store.commit('updateCompanyModal', true)
      }
    },
    handleToUrl (val) {
      if (!this.corpCertityStatus) {
        if (this.admin) {
          this.show = true
        } else if (!this.admin) {
          this.$message({
            message:
              '您的企业尚未完成实名认证，请联系管理员' +
              this.corporationInfo.administrator +
              ':' +
              this.corporationInfo.administratorPhone +
              '进行企业实名认证',
            type: 'warning',
            showClose: true,
          })
        }
      } else {
        window.open(window.location.origin + val)
      }
    },
    handleSaveBtnClick () {
      if (this.creator) {
        window.open(window.location.origin + '/admin/location/index')
      } else {
        window.open(window.location.origin + '/admin/authentication/index')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$header-height: 60px;

#nucarf-saas-head-wrap {
    height: $header-height;
    width: 100%;
    position: relative;
    box-shadow: 0px 2px 4px 0px rgba(236, 240, 241, 1);

    /deep/.el-dropdown {
        padding: 0 !important;
        color: rgba(255, 255, 255, 0.6);
        font-size: 13px;
    }

    .head-left {
        align-items: center;
    }
}

h2 {
    width: 33px;
    height: 37.5px;
    background: url('./images/logo nucarf@3x.png') no-repeat center;
    background-size: 80%;
    display: inline-block;
    text-indent: -9999rem;
    margin-left: 0px;
}

.company-name {
    font-size: 16px;
    font-weight: 400;
    margin-left: 24px;
    flex: 1;

    span {
        cursor: pointer;
    }
}

.icontouxiang {
    font-size: 28px;
    color: hsla(0, 0%, 100%, 0.6);
    font-size: 23px;
}

#nucarf-saas-head {
    height: $header-height;
    background: #323352;
    right: 0;
    color: #fff;
    display: flex;
    padding-left: 4px;
    padding-right: 20px;
    left: 0;
    top: 0;
    align-items: center;
    box-sizing: border-box;
    padding-right: 0;
    z-index: 23;
    box-shadow: 0px 0px 7px 0px rgba(214, 214, 214, 0.5);
}

.financial {
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    color: hsla(0, 0%, 100%, 0.6);
    line-height: 60px;

    i {
        font-size: 18px;
    }

    span {
        margin: 0 5px 0 10px;
        line-height: 60px;
    }
}

.financial:hover {
    background: #464761 !important;
    color: #fff;
}

#nucarf-saas-head > div {
    height: $header-height;
}

#nucarf-saas-head h1 {
    font-size: 18px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    margin-right: 20px;
    height: $header-height;
    line-height: $header-height;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 5px;
    cursor: pointer;
}

#nucarf-saas-head .top-nav {
    flex: 1;
}

#nucarf-saas-head .top-nav,
.seting-nav,
.seting-nav {
    display: flex;
    font-size: 13px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.9);
    height: $header-height;
    line-height: $header-height;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.el-icon-arrow-down {
    transition: all 0.3s;
    font-size: 18px;
}

#nucarf-saas-head .top-nav div:hover {
    color: #fff;
    background: #323352;
}

#nucarf-saas-head .top-nav div {
    padding: 0 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#nucarf-saas-head .right {
    align-items: center;
}

#nucarf-saas-head .nav-user {
    align-items: center;
    padding: 0 16px;
    cursor: pointer;
    height: $header-height;
    display: flex;
    align-items: center;
    color: rgba(250, 255, 255, 0.9);
    margin-right: 24px;
}

#nucarf-saas-head .nav-user:hover {
    color: #fff;
}

#nucarf-saas-head .nav-user span {
    padding: 0 10px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nav-search {
    height: 33px;
    width: 245px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.3);
    padding: 8px 15px;
    box-sizing: border-box;

    input::-webkit-input-placeholder {
        color: rgba(255, 255, 255, 1);
    }

    input {
        color: rgba(255, 255, 255, 1);
        line-height: 17px;
        height: 17px;
        font-size: 12px;
        font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            '微软雅黑', Arial, sans-serif;
        font-weight: 400;
        width: 100%;
    }
}

.transform {
    display: inline-block;
    width: 20% !important;
    margin: 0px 10px 0 20px;
}

.matter {
    padding: 40px 30px 50px 40px;
}

.titleP {
    font-weight: 650;
    color: rgba(0, 0, 0, 0.647058823529412);
    font-size: 16px;
    line-height: 40px;
}

.titlep {
    font-size: 15px;
    line-height: 29px;
    text-indent: 30px;
    color: rgba(0, 0, 0, 0.647058823529412);

    b {
        color: hsla(221, 71%, 44%, 1);
        cursor: zoom-in;
        // cursor: pointer;
    }
}

.el-dialog__footer {
    margin: 0 auto;

    span {
        display: block;
    }

    .flex span {
        padding: 0 15px;
        height: 40px !important;
        line-height: 40px !important;
        border-radius: 4px;
        cursor: pointer;
    }

    .flex {
        .anout {
            color: #666;
            background: #fff;
            margin-left: 30px;
            box-sizing: border-box;
            border: 1px solid rgba(216, 217, 225, 1);
        }

        .blue {
            background: hsla(221, 71%, 44%, 1);
            color: #fff;
        }
    }
}
/deep/ .el-drawer__header {
    height: 79px;
    padding: 0 !important;
    margin: 0 !important;
    border-bottom: 1px solid #f1f1f1;
}

.nav_prod {
    width: 140px;
    height: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #0b1527;
    line-height: 28px;
    margin: 29px 0 32px 26px;
}
.nav_list {
    .active {
        background: #f8f9fc;
    }
    li {
        height: 67px;
        img {
            margin: 14px 21px 15px 27px;
            width: 38px;
            height: 38px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #f1f1f1;
        }
        .nav_title {
            height: 21px;
            margin: 12px 0 5px;
            line-height: 21px;
            color: #333333;
        }
        .nav_dis {
            height: 17px;
            line-height: 17px;
            color: #9b9b9b;
            font-weight: 400;
            font-family: PingFangSC-Regular, PingFang SC;
        }
    }
}
</style>
